module.exports = __webpack_public_path__ + "static/media/req.06c8e96b.jpg";